import { render, staticRenderFns } from "./deviadd.vue?vue&type=template&id=d8ea0da2&scoped=true"
import script from "./deviadd.vue?vue&type=script&lang=js"
export * from "./deviadd.vue?vue&type=script&lang=js"
import style0 from "./deviadd.vue?vue&type=style&index=0&id=d8ea0da2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ea0da2",
  null
  
)

export default component.exports